import React from 'react';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';

export interface SectionLabelProps {
  label: string;
  description?: string;
  withSeparation?: boolean;
}

export const SectionLabel: React.FC<SectionLabelProps> = ({
  label,
  description,
  withSeparation = true,
}) => (
  <Stack gap={4} mt={withSeparation ? 'lg' : undefined}>
    <Text size="sm" fw={600}>
      {label}
    </Text>
    {description && (
      <Text size="xs" c="dimmed">
        {description}
      </Text>
    )}
  </Stack>
);
